import initialState from './state';
import { SET_SIDEBAR_VISIBILITY } from './action-types';

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SIDEBAR_VISIBILITY:
      return {
        ...state,
        sideBarIsVisible: action.sideBarIsVisible,
      };
    default:
      return state;
  }
}

export default reducer;
